import React from 'react';

import Category from 'components/Ui/Category';

import Add from 'containers/Administrator/Grades/Profile/Certificates/Awards/Add';
import Award from 'containers/Administrator/Grades/Profile/Certificates/Awards/Award';

const Awards = ({ studentId, awards }) => {
	return (
		<Category title="Apbalvojumi" hide>
			{/* Show student's awards */}
			{awards?.map(award =>
				<Award key={award.id} award={award} />
			)}

			{/* Add award to student */}
			<Add studentId={studentId} />
		</Category>
	);
};

export default Awards;